import { create } from "zustand";

export const useCredencialesNotificadoresStore = create((set) => ({
  credencialesNotificadores: [],
  credencialNotificador: null,

  setCredencialesNotificadores: (credenciales) =>
    set((state) => {
      return { ...state, credencialesNotificadores: credenciales };
    }),

  setCredencialNotificador: (credencial) =>
    set((state) => {
      return { ...state, credencialNotificador: credencial };
    }),

  updateCredencialNotificador: (credencial) =>
    set((state) => {
      let credenciales = state.credencialesNotificadores.map((item) => {
        if (item.id === credencial.id) {
          return credencial;
        }
        return item;
      });
      return { ...state, credencialesNotificadores: credenciales };
    }),

  agregarCredencialNotificador: (credencial) =>
    set((state) => {
      let credenciales = state.credencialesNotificadores;
      credenciales.push(credencial);
      return { ...state, credencialesNotificadores: credenciales };
    }),
}));
